const BendService = {
    configure: configure,
    post: post,
    event: event,
};

let appKey;
let appSecret;
let encodedCredentials;

function configure(key, secret) {
    appKey = key;
    appSecret = secret;
    encodedCredentials = btoa(`${appKey}:${appSecret}`)
}

function throwConfigError() {
    console.error("Before using BendSerive you must call BendService.config with appKey and appSecret!")
}

function isConfigured() {
    if (!appKey || !appSecret || !encodedCredentials) {
        throwConfigError();
        return false;
    } else {
        return true;
    }
}

function event(eventType, body) {
    if (!isConfigured()) return;
    return fetch(`https://api.bend.io/rpc/${appKey}/custom/log-event`, {
        method: 'post',
        body: JSON.stringify({payload: body, event: eventType} || {}),
        headers: {'Authorization': `Basic ${encodedCredentials}`}
    }).then(function (response) {
        if(!response.ok) throw response;
        return response.json();
    }).catch(e => {
        console.log(e);
        throw e;
    })
}

function post(endpoint, body) {
    if (!isConfigured()) return;
    return fetch(`https://api.bend.io/rpc/${appKey}/custom/${endpoint}`, {
        method: 'post',
        body: JSON.stringify(body || {}),
        headers: {'Authorization': `Basic ${encodedCredentials}`}
    }).then(function (response) {
        if(!response.ok) throw response;
        return response.json();
    }).catch(e => {
        console.log(e);
        throw e;
    })
}

export default BendService;